import React, { Component } from "react";
import { LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { ConfigProvider } from "antd";

import CustomIntlProvider from "./CustomIntlProvider";
import NoData from "../helpers/noData";

import esMessages from "../translations/es_kendo.json";
import enMessages from "../translations/en_kendo.json";
import ptMessages from "../translations/pt_kendo.json";
import es_ES from "antd/es/locale/es_ES";
import en_US from "antd/es/locale/en_US";
import pt_BR from "antd/es/locale/pt_BR";

export function loadTranslationMessages() {
  try {
    loadMessages(esMessages, "es");
    loadMessages(enMessages, "en");
    loadMessages(ptMessages, "pt");
  } catch (error) {
    console.error(error);
  }
}

export class I18nProviderBase extends Component {
  state = {
    loaded: false,
  };
}

export class I18nProvider extends I18nProviderBase {
  render() {
    let locale = localStorage.getItem("locale");
    if (!locale) {
    } //Obtener del navegador
    if (!locale) {
      locale = "en-US";
    }
    let language = !locale ? null : locale.substr(0, 2);

    const antdLocale =
      locale === "en-US" ? en_US : locale === "es-ES" ? es_ES : pt_BR;

    return (
      <CustomIntlProvider locale={locale}>
        <LocalizationProvider language={language}>
          <ConfigProvider locale={antdLocale} renderEmpty={() => <NoData />}>
            {this.props.children}
          </ConfigProvider>
        </LocalizationProvider>
      </CustomIntlProvider>
    );
  }
}
